import { Controller } from "stimulus";

// Appends a Beta badge to every element marked as an anchor target, so
// components don't need to know about beta features.
export default class extends Controller {
  static targets = ["template", "anchor"];

  anchorTargetConnected(element) {
    if (element.querySelector("[data-beta-badge]")) return;

    element.append(this.templateTarget.content.cloneNode(true));
  }
}
